// Profile Module - Root Reducers
// This file aggregates all profile-related reducers

import ProfileReducer from './Profile/store/slice'
import ProfileSecurityReducer from './Security/store/slice'

// Combine all profile reducers
const profileReducers = {
  ...ProfileReducer,
  ...ProfileSecurityReducer,
}

export default profileReducers

